module.exports = __webpack_public_path__ + "static/media/learn-anytime-anywhere.c73a40ac.png";